import useRoutes from './useRoutes';
import useLocalStorageKey from './useLocalStorageKey';
import { wipePersistedPreferences } from '../utils/wipePersistedPreferences';
import { deleteAllFormTokenMetaRecords } from '../utils/formTokensStorage/deleteAllFormTokenMetaRecords';

const useRestartApp = () => {
  const routes = useRoutes();
  const storageKey = useLocalStorageKey();

  const restartApp = async (): Promise<void> => {
    // delete must finish before navigation aborts the IndexedDB transaction
    await deleteAllFormTokenMetaRecords(storageKey);
    wipePersistedPreferences(storageKey);
    window.location.assign(routes.dashboards());
  };

  return { restartApp };
};

export default useRestartApp;
